import { render } from "./MarqueeDisplay.vue?vue&type=template&id=2eb14074&scoped=true"
import script from "./MarqueeDisplay.vue?vue&type=script&lang=js"
export * from "./MarqueeDisplay.vue?vue&type=script&lang=js"

import "./MarqueeDisplay.vue?vue&type=style&index=0&id=2eb14074&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb14074"]])

export default __exports__